export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-geo/src/identity.js
// module id = r5YO
// module chunks = 0